// extracted by mini-css-extract-plugin
export default {"container":"HomePage_container__ONGTf","body":"HomePage_body__LNcpS"};